var $ = require('jquery');

var msg = jimdoData.messages.guidedSetup;

/* default step variables */
var defaults = {};
var steps = [
    {
        id: 'businessIdentity',
        recommendable: 'PersonalData',
        minStatusRank: 3,
        title: msg.step.myData.title,
        description: msg.step.myData.description,
        tooltip: {
            finished: msg.step.myData.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            var openParams = [
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'personal-data'}
            ];

            diy.editor.deeplinking.requestPath(openParams);
        }
    },
    {
        id: 'topic',
        recommendable: 'SelectTopic',
        minStatusRank: 2,
        title: msg.step.topic.title,
        description: msg.step.topic.description,
        tooltip: {
            finished: msg.step.topic.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            var openParams = [
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'industry'}
            ];
            diy.editor.deeplinking.requestPath(openParams);
        },
        unavailable: msg.step.topic.unavailable
    },
    {
        id: 'vcard',
        recommendable: 'MaintenanceMode',
        minStatusRank: 2,
        title: msg.step.vcard.title,
        description: msg.step.vcard.description,
        tooltip: {
            finished: msg.step.vcard.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            $(document).trigger('diy-maintenance-mode-edit');
        }
    },
    {
        id: 'learnTheInterface',
        recommendable: 'GuidedAudioTour',
        minStatusRank: 1,
        title: msg.step.learnTheInterface.title,
        description: msg.step.learnTheInterface.description,
        tooltip: {
            finished: msg.step.learnTheInterface.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.guidance.start();
        }
    },
    {
        id: 'style',
        recommendablesOR: [
            {
                recommendable: 'Styling',
                minStatusRank: 2
            },
            {
                recommendable: 'Theming',
                minStatusRank: 2
            }
        ],
        title: msg.step.style.title,
        description: msg.step.style.description,
        tooltip: {
            finished: msg.step.style.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            jQuery('#cc-sa-item-style').trigger('click');
        }
    },
    {
        id: 'nav',
        recommendable: 'Navigation',
        minStatusRank: 2,
        title: msg.step.nav.title,
        description: msg.step.nav.description,
        tooltip: {
            finished: msg.step.nav.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            diy.editor.navigation.api.openEditor();
        }
    },
    {
        id: 'elements',
        recommendable: 'InsertElement',
        minStatusRank: 2,
        title: msg.step.elements.title,
        description: msg.step.elements.description,
        tooltip: {
            finished: msg.step.elements.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            jQuery('#cc-sa-item-elements').trigger('click');
        }
    },
    {
        id: 'sections',
        recommendable: 'InsertSection',
        minStatusRank: 2,
        title: msg.step.sections.title,
        description: msg.step.sections.description,
        tooltip: {
            finished: msg.step.sections.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            jQuery('#cc-sa-item-sections').trigger('click');
        }
    },
    {
        id: 'internetAddress',
        recommendable: 'Domain',
        minStatusRank: 1,
        title: msg.step.internetAddress.title,
        description: msg.step.internetAddress.description,
        tooltip: {
            finished: msg.step.internetAddress.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();

            var goDirectly = $('.gs-container').attr('data-domain-connect-directly') === "1";
            if (goDirectly) {
                diy.util.redirector.redirectToLabel('domain_connect_redirect-guidedsetup');
            } else {
                jQuery('#cc-sa-item-settings').trigger('click');
                $(document).one('diy-siteadmin-sac-ready', function (e, wnd) {
                    wnd.jQuery('#website-domain', wnd.document).trigger('click');
                });
            }
        }
    },
    {
        id: 'emailAddress',
        recommendable: 'EmailAddress',
        minStatusRank: 1,
        title: msg.step.emailAddress.title,
        description: msg.step.emailAddress.description,
        tooltip: {
            finished: msg.step.emailAddress.tooltip.finished
        },
        getDependentStep: function () {
            return 'internetAddress'; // 5th step (internetAddress)
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            diy.util.redirector.redirectToLabel('choose_an_email_redirect_from_guidedSetup');
        },
        dependable: msg.step.emailAddress.dependable
    },
    {
        id: 'publish',
        recommendable: 'PublishWebsite',
        minStatusRank: 3,
        title: msg.step.publish.title,
        description: msg.step.publish.description,
        tooltip: {
            finished: msg.step.publish.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            $(document).trigger('diy-maintenance-mode-show');
        },
        unavailable: msg.step.publish.unavailable
    }
];

var getStepOptions = function () {

    var skipSteps = {};
    if (jimdoData.guidedSetupData.hasOwnProperty('skipSteps')) {
        skipSteps = jimdoData.guidedSetupData.skipSteps;
    }
    var opts = [];

    for (var i = 0; i < steps.length; i++) {
        if (!(steps[i].id in skipSteps)) {
            var stepOpts = $.extend(true, {}, defaults, steps[i]);
            opts.push(stepOpts);
        }
    }
    return opts;
};

module.exports = {
    getStepOptions: getStepOptions
};




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/guided-setup/steps.js
 ** module id = 733
 ** module chunks = 0
 **/